import React, { PropTypes } from "react";
import { NitroHeading } from "nitro-components";
import styled from "styled-components";

const HeadingContainer = styled.div`
	overflow: hidden;
	text-align: center;
	margin-bottom: ${props => props.marginBottom};
	width: ${props => props.width};

	&:before, &:after {
		background-color: ${props => props.theme.color.border};
		content: "";
		display: inline-block;
		height: 1px;
		position: relative;
		vertical-align: middle;
		width: 50%;
	}

	&:before {
		right: 1em;
 		margin-left: -50%;
	}

	&:after {
		left: 1em;
 		margin-right: -50%;
	}
`;

const DecoratedHeading = props => (
	<HeadingContainer marginBottom={props.marginBottom} width={props.width}>
		<NitroHeading
			inline
			align="center"
			label={props.label}
			variant={props.variant}
			size={props.size}
			noMargin
		/>
	</HeadingContainer>
);

DecoratedHeading.propTypes = {
	label: PropTypes.string,
	variant: PropTypes.string,
	size: PropTypes.string,
	marginBottom: PropTypes.string,
	width: PropTypes.string
};

export default DecoratedHeading;



// WEBPACK FOOTER //
// ./src/components/common/DecoratedHeading.js